<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-menu bottom left>
        <template v-slot:activator="{ on }">
            <v-btn
                    fab
                    dark
                    icon
                    v-on="on"
            >
                <v-icon>send</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item @click="sendTestMessage('vk')">
                <v-list-item-title>ВКонтакте</v-list-item-title>
            </v-list-item>
            <v-list-item @click="sendTestMessage('tg')">
                <v-list-item-title>Telegram</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'TestMessageSender',
    props: {
        modelId: {
            type: Number,
            default: null
        },
        typeModel: {
            type: String,
            default: 'message'
        }
    },
    data() {
        return {
            bot: null
        }
    },
    methods: {
        sendTestMessage(platform) {
            if (this.modelId == null) {
                this.$emit('testMessageSenderNotification', { color: 'error', text: 'Сначала создайте сообщение!' })
                return null
            }
            if (platform === 'vk' && this.bot.token_vk !== '1') {
                this.$emit('testMessageSenderNotification', { color: 'error', text: 'Не подключен бот в ВКонтакте!' })
                return null
            }
            if (platform === 'vk' && this.user.id == null) {
                this.$emit('testMessageSenderNotification', { color: 'error', text: 'Не подключен ваш профиль к ВКонтакте!' })
                return null
            }
            if (platform === 'tg' && this.bot.token_tg !== '1') {
                this.$emit('testMessageSenderNotification', { color: 'error', text: 'Не подключен бот в Telegram!' })
                return null
            }
            if (platform === 'tg' && this.user.id_tg == null) {
                this.$emit('testMessageSenderNotification', { color: 'error', text: 'Не подключен ваш профиль к Telegram!' })
                return null
            }
            this.$store.dispatch('mailings/sendTestMessage', {
                model_id: this.modelId,
                bot_id: this.bot.id,
                type: this.typeModel,
                platform: platform
            }).then(response => {
                if (response.ok) {
                    this.$emit('testMessageSenderNotification', { color: 'success', text: 'Сообщение успешно отправлено!' })
                }
            })
        }
    },
    computed: {
        ...mapGetters({
            getBotById: 'bots/getBotById',
            user: 'user/user'
        })
    },
    created() {
        this.bot = this.getBotById(+this.$route.params['pathMatch'])
    }
}
</script>

<style scoped>

</style>
